var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[_c('button',{class:`custom-button ${_vm.parseClass()}`,on:{"click":function($event){return _vm.executeFunction()}}},[_c('div',{class:_vm.parseSVG()}),_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }